// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"78d6bba7","977":"477ca17e"}[chunkId] + ".chunk.js";
};